import { useEffect, useState } from 'react';

// Service
import ArchingService from '../../services/ArchingService';
import useQueryString from '../queryString/useQueryString';

//Hooks
import useUser from "../user/useUser";

const initialState = {
    items: [],
    totalResults: 0,
    totalPage: 1,
    filters: {
        branchId: '',
        from: '',
        to: '',
        pageSize: 10,
        pageNumber: 1,
    }
}

const useArchings = () => {
    const { branch } = useUser();
    const [archingsState, setArchingsState] = useState(initialState);
    const { setParameterSearch, filters, clearFilters, search, GetQueryString } = useQueryString({ ...initialState.filters });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const SearchArchings = async () => {
            setLoading(true);
            await ArchingService
                .SearchArchings(GetQueryString(), branch?.id)
                .then(res =>
                    setArchingsState({
                        ...archingsState,
                        items: res.values.map(item => ({
                            ...item,
                            type: !item.closureId
                                ? 'Efectivo'
                                : 'Cierre',
                            diffDisplay: item?.diff > 0
                                ? ("+" + item?.diff)
                                : item?.diff
                        })),
                        totalResults: res.totalResults,
                        totalPage: res.totalPage
                    }))
                .finally(() => setLoading(false));
        }
        if ((search && search !== '') && (branch && branch?.id && branch?.id !== 0))
            SearchArchings();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search, branch?.id])

    return {
        archings: archingsState.items,
        loading,
        totalPage: archingsState.totalPage,
        setParameterSearch,
        filters,
        clearFilters
    }
}

export default useArchings;